import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Checkbox,
  FormControlLabel,
  Modal,
  IconButton,
  alpha,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import { useNavigate } from "react-router-dom";
import Chart from "chart.js/auto";
import "chartjs-adapter-date-fns";
import "chartjs-plugin-crosshair";
import { useSelector } from "react-redux";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { Line } from "react-chartjs-2";
import "chartjs-plugin-crosshair";
import {
  Chart as ChartJS,
  LineElement,
  TimeScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import "chartjs-adapter-date-fns";
import ModalContent from "../../Common/Modal";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

ChartJS.register(LineElement, TimeScale, LinearScale, PointElement, Tooltip, Legend);

const COPYTRADINGSERVICE = WEBSERVICE + "/copyTrading";

const MarketPlace = () => {
  const navigate = useNavigate();
  const { brokerBasicInfo, btncolor } = useSelector((state) => state);
  const [brokerMarkets, setBrokerMarkets] = useState({});
  const [activeTab, setActiveTab] = useState(
    Number(localStorage.getItem("marketPlaceActiveTab")) || 0
  );
  const [showFollowedOnly, setShowFollowedOnly] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedApiKey, setSelectedApiKey] = useState([]);
  const [apiKey, setApiKey] = useState("");
  const [tradeApiKeyStatus, setTradeApiKeyStatus] = useState(true);
  const [botTraderStatus, setBotTraderStatus] = useState(false);
  const [traderName, setTraderName] = useState(null);
  const [exchangeName, setExchangeName] = useState("All Exchanges");
  const [timePeriod, setTimePeriod] = useState("All Time");
  const [traderNameFilter, setTraderNameFilter] = useState("");
  const [marketType, setMarketType] = useState("All Markets");
  const [baseCurrency, setBaseCurrency] = useState("All");
  const [minTrade, setMinTrade] = useState("");
  const [isFollowStatus, setIsFollowStatus] = useState(0);
  const [traderApiMarketCard, setTraderApiMarketCard] = useState([]);
  const [traderBotsMarketCard, setTraderBotsMarketCard] = useState([]);
  const [traderRole, setTraderRole] = useState(localStorage.getItem("traderRole") || "trader");
  const [chartBody, setChartBody] = useState([]);
  const [chartBodyTrimmed, setChartBodyTrimmed] = useState([]);
  const [chartBodyTrimmed1, setChartBodyTrimmed1] = useState([]);
  const [chartBodyBot, setChartBodyBot] = useState([]);
  const [chartBodyBotTrimmed, setChartBodyBotTrimmed] = useState([]);
  const [chartBodyBotTrimmed1, setChartBodyBotTrimmed1] = useState([]);
  const [subscriptionPrice, setSubscriptionPrice] = useState(null);
  const [baseCurrencyFromApi, setBaseCurrencyFromApi] = useState(null);
  const [apiBotId, setApiBotId] = useState(null);
  const [isBotApi, setIsBotApi] = useState(null);
  const [check, setCheck] = useState(false);

  const chartRefs = useRef([]);
  const handleClose = () => setOpen(false);

  const getAllApiKeys = (marketType, exchange_name) => {
    const payload = { customerId: localStorage.getItem("userId"), marketType, exchange_name };
    axios
      .post(`${WEBSERVICE}copyTrading/bot/getAPIKeyCopyTrader`, JSON.stringify(payload), {
        headers: { "Content-Type": "application/json", authorization: "BEARER " + localStorage.getItem("access_token") },
      })
      .then((response) => {
        const result = response.data;
        if (result.error.error_data !== 0) showToast("error", result.error.error_msg);
        else setSelectedApiKey(result.keyDetails || []);
      })
      .catch(() => { showToast("error", "Internal Server Error"); });
  };

  const followTrader = async () => {
    const updateAPI = { botId: apiBotId, customerId: localStorage.getItem("userId"), isBotOrApi: isBotApi, copyTraderApiKeyId: apiKey };
    try {
      const response = await axios.post(
        "https://accounts.paybito.com/api/copyTrading/bot/CreateBotFollowers",
        JSON.stringify(updateAPI),
        { headers: { "Content-Type": "application/json", Authorization: "BEARER " + localStorage.getItem("access_token") } }
      );
      setOpen(false);
      if (response.data.error.error_data === 0) showToast("success", response.data.error.error_msg);
      else showToast("error", response.data.error.error_msg);
      window.location.reload();
    } catch {
      setOpen(false);
      showToast("error", "An error occurred. Please try again.");
      window.location.reload();
    }
  };

  useEffect(() => {
    getApiMarketDataFilter(tradeApiKeyStatus);
    getAllBrokerMarkets();
    getTraderName();
    handleTabChange(null, activeTab);
  }, [activeTab]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setTradeApiKeyStatus(newValue === 0);
    setBotTraderStatus(newValue === 1);
    getApiMarketDataFilter(newValue === 0);
    localStorage.setItem("marketPlaceActiveTab", newValue);
  };

  useEffect(() => {
    if (tradeApiKeyStatus) {
      if (traderApiMarketCard?.length !== 0) createChart();
    } else {
      if (traderBotsMarketCard?.length !== 0) createChartBot();
    }
  }, [tradeApiKeyStatus]);

  function createChartBot() {
    setTimeout(() => {
      const updatedCards = [...traderBotsMarketCard];
      for (let x = 0; x <= chartBodyBotTrimmed1.length; x++) {
        const iter = chartBodyBotTrimmed1[x];
        if (iter !== undefined) {
          const arr = [];
          iter.forEach((element) => {
            const refinedString = element.slice(1, -1);
            const refinedValue = refinedString.split(",");
            arr.push({ x: parseInt(refinedValue[0]), y: refinedValue[1] });
          });
          if (updatedCards[x]) updatedCards[x].chartBodyModified = arr;
        }
      }
      updatedCards.forEach((card, i) => {
        const canvas = document.getElementById("myChartBot" + i);
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        new Chart(ctx, {
          type: "line",
          data: { datasets: [{ data: card.chartBodyModified, borderColor: "#008ffb", fill: false, pointRadius: 2, borderWidth: 3 }] },
          options: { plugins: { crosshair: false, legend: { display: false } }, scales: { xAxes: [{ type: "time" }] } },
        });
      });
      setTraderBotsMarketCard(updatedCards);
    }, 2000);
  }

  const createChart = () => {
    setTimeout(() => {
      chartBodyTrimmed1?.forEach((iter, x) => {
        if (iter !== undefined) {
          let arr = [];
          iter?.forEach((element) => {
            let refinedString = element.slice(1, -1);
            let refinedValue = refinedString.split(",");
            arr.push({ x: parseInt(refinedValue[0]), y: refinedValue[1] });
          });
          const updatedMarketCard = [...traderApiMarketCard];
          updatedMarketCard[x] = { ...updatedMarketCard[x], chartBodyModified: arr };
          setTraderApiMarketCard(updatedMarketCard);
        }
      });
    }, 2000);
  };

  const getAllBrokerMarkets = async () => {
    const BROKERID = localStorage.getItem("BROKERID");
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");
    try {
      const response = await axios.post(
        `${WEBSERVICE}user/brokerCryptoMarket`,
        JSON.stringify({ brokerId: BROKERID, uuid }),
        { headers: { "Content-Type": "application/json", Authorization: `BEARER ${accessToken}` } }
      );
      setBrokerMarkets(response.data.brokerCryptoMarket);
    } catch (error) { console.error("Error fetching broker markets:", error); }
  };

  const getTraderName = async () => {
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get(
        "https://accounts.paybito.com/api/copyTrading/marketPlace/GetTraderName",
        { headers: { "Content-Type": "application/json", Authorization: `BEARER ${token}` } }
      );
      setTraderName(response.data.traderNameDetails);
    } catch (error) { console.error("Error fetching trader names:", error); }
  };

  const getBaseCurrency = (val) => {
    if (val === "Spot") getAllBaseCurrency(1);
    else if (val === "Futures") getAllBaseCurrency(2);
    else if (val === "Options") getAllBaseCurrency(3);
  };

  const getAllBaseCurrency = (e) => {
    const token = localStorage.getItem("access_token");
    axios
      .get(`${WEBSERVICE}home/baseCurrenciesByMarket/${e}`, {
        headers: { "Content-Type": "application/json", authorization: "BEARER " + token },
      })
      .then((response) => { setBaseCurrencyFromApi(response.data.assetPairList); })
      .catch((error) => { console.error("Error fetching base currencies:", error); });
  };

  const followCheckBox = (event) => {
    setCheck(event.target.checked);
    setIsFollowStatus(event.target.checked ? 1 : 0);
  };

  const getApiMarketDataFilter = (flag) => {
    const updateAPI = {
      timeRange: timePeriod, traderName: traderNameFilter, allMarket: marketType,
      baseCurrency, minTradeQty: minTrade, showFollowedOnly: isFollowStatus,
      exchange_name: exchangeName, customerId: localStorage.getItem("userId"),
    };
    axios
      .post(
        `https://accounts.paybito.com/api/copyTrading/marketPlace/GetMarketPlaceApiKeyChartHeader/${flag ? "apiKey" : "bots"}`,
        JSON.stringify(updateAPI),
        { headers: { "Content-Type": "application/json", Authorization: `BEARER ${localStorage.getItem("access_token")}` } }
      )
      .then((response) => {
        const fetchedTraderApiMarketCard = response.data.getChartHeader;
        if (flag) setTraderApiMarketCard(fetchedTraderApiMarketCard);
        else setTraderBotsMarketCard(fetchedTraderApiMarketCard);
        const newChartBody = [];
        fetchedTraderApiMarketCard?.forEach((item) => { newChartBody.push(item.chartBody); });
        setChartBody(newChartBody);
        const newChartBodyTrimmed1 = [];
        newChartBody.forEach((body) => { newChartBodyTrimmed1.push(body.split("|")); });
        setChartBodyTrimmed1(newChartBodyTrimmed1);
      })
      .catch((error) => { console.error("Error fetching market data:", error); });
  };

  const viewTraderBot = (id, type) => { navigate(`/apiKey/${id}?type=${type}`); };

  const openSubscriptionInfoModal = (price, id, marketType, exchange_name, isBotApiValue) => {
    setSubscriptionPrice(price);
    setApiBotId(id);
    setIsBotApi(isBotApiValue);
    getAllApiKeys(marketType, exchange_name);
    setOpen(true);
  };

  const parseChartBody = (chartBodyStr) => {
    if (!chartBodyStr) return [];
    return chartBodyStr
      .split("|")
      .map((item) => item.replace(/[{}]/g, ""))
      .map((pair) => {
        const [timestampSec, value] = pair.split(",").map(Number);
        return { x: timestampSec * 1000, y: value };
      });
  };

  const currentCards = tradeApiKeyStatus ? traderApiMarketCard : traderBotsMarketCard;

  return (
    <Box sx={pageWrapper}>
      {/* Hero Banner */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <StorefrontOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={heroTitle}>Marketplace</Typography>
            <Typography sx={heroSubtitle}>
              Browse top traders and bots — follow their strategies and start copy trading
            </Typography>
          </Box>
          <ContainedButton
            variant="contained"
            onClick={() => { localStorage.setItem("marketPlaceActiveTab", 0); navigate("/copy-trade"); }}
            sx={backBtn}
          >
            Back
          </ContainedButton>
        </Box>
      </Box>

      {/* Main Card */}
      <Box sx={mainCard}>
        {/* Tabs */}
        <Box sx={tabsWrap}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              ...tabsStyle,
              "& .MuiTabs-indicator": { backgroundColor: btncolor, height: 3, borderRadius: "3px 3px 0 0" },
              "& .Mui-selected": { color: `${btncolor} !important` },
            }}
          >
            <Tab
              iconPosition="start"
              icon={<PersonOutlinedIcon sx={{ fontSize: 18 }} />}
              label="Trader API Keys"
              sx={tabItem}
            />
            <Tab
              iconPosition="start"
              icon={<SmartToyOutlinedIcon sx={{ fontSize: 18 }} />}
              label="Trader Bots"
              sx={tabItem}
            />
          </Tabs>
        </Box>

        {/* Filter Section */}
        <Box sx={filterSection}>
          <Box sx={filterHeader}>
            <FilterAltOutlinedIcon sx={{ ...filterHeaderIcon, color: btncolor }} />
            <Typography sx={filterHeaderText}>Filter Marketplace</Typography>
          </Box>
          <Box sx={filterGrid}>
            <FormControl sx={filterFieldStyle}>
              <InputLabel sx={filterInputLabel}>Exchange</InputLabel>
              <Select label="Exchange" value={exchangeName} onChange={(e) => setExchangeName(e.target.value)} sx={modernSelectStyle}>
                <MenuItem value="All Exchanges">All</MenuItem>
                <MenuItem value="PAYBITO">{brokerBasicInfo?.companyName}</MenuItem>
                <MenuItem value="BINANCE">BINANCE</MenuItem>
              </Select>
            </FormControl>

            <FormControl sx={filterFieldStyle}>
              <InputLabel sx={filterInputLabel}>Time Period</InputLabel>
              <Select label="Time Period" value={timePeriod} onChange={(e) => setTimePeriod(e.target.value)} sx={modernSelectStyle}>
                <MenuItem value="All Time">All Time</MenuItem>
                <MenuItem value="Last Month">Last Month</MenuItem>
                <MenuItem value="Last Week">Last Week</MenuItem>
              </Select>
            </FormControl>

            <FormControl sx={filterFieldStyle}>
              <InputLabel sx={filterInputLabel}>Trader</InputLabel>
              <Select label="Trader" value={traderNameFilter} onChange={(e) => setTraderNameFilter(e.target.value)} sx={modernSelectStyle}>
                <MenuItem value="">Select Any</MenuItem>
                {traderName?.map((t) => (
                  <MenuItem key={t.traderName} value={t.traderName}>{t.traderName}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={filterFieldStyle}>
              <InputLabel sx={filterInputLabel}>Market</InputLabel>
              <Select
                label="Market"
                value={marketType}
                onChange={(e) => { setMarketType(e.target.value); getBaseCurrency(e.target.value); }}
                sx={modernSelectStyle}
              >
                <MenuItem value="All Markets">All Markets</MenuItem>
                {brokerMarkets?.spot === 1 && <MenuItem value="Spot">Spot</MenuItem>}
                {brokerMarkets?.futures === 1 && <MenuItem value="Futures">Futures</MenuItem>}
              </Select>
            </FormControl>

            <FormControl sx={filterFieldStyle}>
              <InputLabel sx={filterInputLabel}>Base Currency</InputLabel>
              <Select label="Base Currency" value={baseCurrency} onChange={(e) => setBaseCurrency(e.target.value)} sx={modernSelectStyle}>
                <MenuItem value="All">All</MenuItem>
                {baseCurrencyFromApi?.map((m) => (
                  <MenuItem key={m.baseCurrency} value={m.baseCurrency}>{m.baseCurrency}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Min Trade Qty"
              value={minTrade}
              onChange={(e) => setMinTrade(e.target.value)}
              sx={{ ...filterFieldStyle, ...modernSelectStyle }}
              size="small"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={check}
                  onChange={followCheckBox}
                  sx={{ color: btncolor, "&.Mui-checked": { color: btncolor } }}
                />
              }
              label={<Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)" }}>Followed only</Typography>}
            />

            <ContainedButton
              variant="contained"
              onClick={() => getApiMarketDataFilter(tradeApiKeyStatus)}
              sx={{ height: 40, px: 3, borderRadius: "10px", textTransform: "none", fontWeight: 600, fontSize: "0.85rem" }}
            >
              Apply Filters
            </ContainedButton>
          </Box>
        </Box>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.12)" }} />

        {/* Cards Grid */}
        <Box sx={{ p: { xs: 1.5, md: 2.5 } }}>
          {currentCards?.length > 0 ? (
            <Grid container spacing={2.5}>
              {currentCards.map((data, i) => (
                <Grid size={{ xs: 12, sm: 6, md: 4 }} key={data.id}>
                  <Box sx={traderCard}>
                    {/* Card top strip */}
                    <Box sx={{ ...cardTopStrip, background: `linear-gradient(90deg, ${alpha(btncolor || "#1976d2", 0.85)}, ${alpha(btncolor || "#1976d2", 0.4)})` }} />

                    <Box sx={cardBody}>
                      {/* Header */}
                      <Box sx={cardHeader}>
                        <Box sx={traderAvatar}>
                          <img
                            src={data.profileLink ?? "https://i.imgur.com/wvxPV9S.png"}
                            height="44"
                            width="44"
                            style={{ borderRadius: "50%", display: "block", objectFit: "cover" }}
                            alt={data.apiKeyName}
                          />
                        </Box>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography sx={traderName2}>{data.apiKeyName}</Typography>
                          <Typography sx={traderSubName}>{data.tradeName}</Typography>
                        </Box>
                        <Box sx={subscriptionTag}>
                          <Typography sx={subscriptionTagText}>
                            {data.monthlySubscriptionCharge} USDT/mo
                          </Typography>
                        </Box>
                      </Box>

                      {/* Chart */}
                      <Box sx={chartWrap}>
                        <Line
                          key={i}
                          ref={(el) => (chartRefs.current[i] = el)}
                          data={{
                            datasets: [{
                              data: parseChartBody(data.chartBody) || [],
                              borderColor: "#008ffb",
                              fill: false,
                              pointRadius: 2,
                              borderWidth: 2,
                            }],
                          }}
                          options={{
                            plugins: { legend: { display: false }, crosshair: false },
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                              x: { type: "time", display: false },
                              y: { display: false },
                            },
                            interaction: { mode: "index", intersect: false },
                          }}
                        />
                      </Box>

                      {/* PnL */}
                      <Box sx={pnlWrap}>
                        <Typography sx={pnlLabel}>P/L</Typography>
                        <Typography
                          sx={{
                            ...pnlValue,
                            color: String(data.pnl).startsWith("-") ? "#ef4444" : "#16a34a",
                          }}
                        >
                          {data.pnl}
                        </Typography>
                      </Box>

                      {/* Actions */}
                      <Box sx={cardActions}>
                        <OutlinedButton
                          variant="outlined"
                          size="small"
                          onClick={() => viewTraderBot(data.id, tradeApiKeyStatus ? "apiKey" : "bots")}
                          sx={cardActionBtn}
                        >
                          View {tradeApiKeyStatus ? "Trader" : "Bot"}
                        </OutlinedButton>

                        {data.isFollowed === "2" ? (
                          <ContainedButton
                            variant="contained"
                            size="small"
                            onClick={() =>
                              openSubscriptionInfoModal(
                                data.monthlySubscriptionCharge, data.id,
                                data?.marketType, data?.exchange_name,
                                tradeApiKeyStatus ? "apiKey" : "bots"
                              )
                            }
                            disabled={traderRole !== "copyTrader" && data.allowCopyTrading === "0"}
                            sx={cardActionBtn}
                          >
                            Follow {tradeApiKeyStatus ? "Trader" : "Bot"}
                          </ContainedButton>
                        ) : (
                          <OutlinedButton variant="outlined" size="small" disabled sx={cardActionBtn}>
                            {data.isFollowed === "1" ? "Following" : "My API"}
                          </OutlinedButton>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Box sx={emptyState}>
              <InboxOutlinedIcon sx={emptyIcon} />
              <Typography sx={emptyText}>No traders or bots found</Typography>
              <Typography sx={{ fontSize: "0.78rem", color: "var(--text-color)", opacity: 0.45, mt: 0.5 }}>
                Try adjusting your filters
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* Subscription Modal */}
      <ModalContent open={open} onClose={handleClose} title="Subscription Info">
        <form onSubmit={(e) => { e.preventDefault(); followTrader(); }}>
          <TextField
            fullWidth label="Price" value={`${subscriptionPrice} USDT/mo`}
            InputProps={{ readOnly: true }} margin="normal" variant="outlined"
            sx={dialogTextField}
          />
          <TextField
            fullWidth label="Period" value="30 days"
            InputProps={{ readOnly: true }} margin="normal" variant="outlined"
            sx={dialogTextField}
          />
          <FormControl fullWidth margin="normal">
            <InputLabel id="API Key">API Key</InputLabel>
            <Select labelId="API Key" label="API Key" onChange={(e) => setApiKey(e.target.value)} sx={modernSelectStyle}>
              <MenuItem value="">Select Any</MenuItem>
              {selectedApiKey?.map((d, i) => (
                <MenuItem key={i} value={d?.apiKeyId}>{d?.apiKeyName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <ContainedButton type="submit" variant="contained" sx={{ mt: 2, borderRadius: "10px", textTransform: "none", fontWeight: 600 }} fullWidth>
            Subscribe
          </ContainedButton>
        </form>
      </ModalContent>
    </Box>
  );
};

// ── Styles ─────────────────────────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
  flexWrap: "wrap",
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 540,
};

const backBtn = {
  height: 40,
  px: 2.5,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.85rem",
  flexShrink: 0,
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.3)",
  color: "#fff",
  "&:hover": { backgroundColor: "rgba(255,255,255,0.28)" },
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const tabsWrap = {
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  px: { xs: 1, md: 2 },
  backgroundColor: "var(--body-color-less2)",
};

const tabsStyle = {
  minHeight: 56,
  "& .MuiTab-root": { minHeight: 56 },
};

const tabItem = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  color: "var(--text-color)",
  opacity: 0.65,
  letterSpacing: "0.01em",
  px: 2,
  gap: 0.75,
  "&.Mui-selected": { color: "var(--text-color)", opacity: 1 },
};

const filterSection = {
  p: { xs: 1.5, md: 2.5 },
};

const filterHeader = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  mb: 2,
};

const filterHeaderIcon = { fontSize: 18 };

const filterHeaderText = {
  fontSize: "0.85rem",
  fontWeight: 600,
  color: "var(--text-color)",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

const filterGrid = {
  display: "flex",
  flexWrap: "wrap",
  gap: 1.5,
  alignItems: "center",
};

const filterFieldStyle = {
  minWidth: 140,
  maxWidth: 180,
};

const filterInputLabel = {
  color: "var(--text-color)",
  opacity: 0.6,
  fontSize: "0.85rem",
};

const modernSelectStyle = {
  "& .MuiInputBase-root": {
    height: "44px",
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "0.85rem",
  },
  "& .MuiSelect-select": { color: "var(--text-color)" },
  "& .MuiSvgIcon-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.25)" },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.45)" },
  "& .MuiInputLabel-root": { color: "var(--text-color)", opacity: 0.6 },
};

// Trader cards
const traderCard = {
  backgroundColor: "var(--body-color-less)",
  border: "1px solid rgba(125,125,125,0.13)",
  borderRadius: "16px",
  overflow: "hidden",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  "&:hover": { transform: "translateY(-3px)", boxShadow: "0 12px 32px rgba(0,0,0,0.12)" },
  height: "100%",
};

const cardTopStrip = { height: 4, width: "100%" };

const cardBody = {
  p: 2,
  display: "flex",
  flexDirection: "column",
  gap: 0,
};

const cardHeader = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  mb: 1.5,
};

const traderAvatar = {
  width: 48,
  height: 48,
  borderRadius: "50%",
  border: "2px solid rgba(125,125,125,0.18)",
  backgroundColor: "var(--body-color-less2)",
  overflow: "hidden",
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const traderName2 = {
  fontSize: "0.9rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const traderSubName = {
  fontSize: "0.72rem",
  color: "var(--text-color)",
  opacity: 0.5,
  mt: 0.15,
};

const subscriptionTag = {
  flexShrink: 0,
  backgroundColor: "rgba(125,125,125,0.1)",
  borderRadius: "8px",
  px: 0.9,
  py: 0.35,
};

const subscriptionTagText = {
  fontSize: "0.68rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.7,
  whiteSpace: "nowrap",
};

const chartWrap = {
  height: 140,
  mb: 1.5,
  borderRadius: "10px",
  overflow: "hidden",
  backgroundColor: "var(--body-color-less2)",
  p: 1,
};

const pnlWrap = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 1.5,
  px: 0.5,
};

const pnlLabel = {
  fontSize: "0.72rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  color: "var(--text-color)",
  opacity: 0.45,
};

const pnlValue = {
  fontSize: "1rem",
  fontWeight: 800,
  letterSpacing: "-0.01em",
};

const cardActions = {
  display: "flex",
  gap: 1,
};

const cardActionBtn = {
  flex: 1,
  borderRadius: "9px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.78rem",
  height: 36,
};

const emptyState = {
  textAlign: "center",
  py: 8,
};

const emptyIcon = {
  fontSize: 52,
  color: "var(--text-color)",
  opacity: 0.3,
  mb: 1,
};

const emptyText = {
  fontSize: "0.92rem",
  color: "var(--text-color)",
  opacity: 0.55,
};

const dialogTextField = {
  "& .MuiInputBase-root": {
    borderRadius: "10px",
    backgroundColor: "var(--body-color-less2)",
    color: "var(--text-color)",
    fontSize: "0.88rem",
  },
  "& .MuiInputBase-input": { color: "var(--text-color)" },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.25)" },
  "& .MuiInputLabel-root": { color: "var(--text-color)", opacity: 0.6 },
};

export default MarketPlace;
